// Registre des langues de l'interface. Ajouter une langue : un dossier locales/<code>/ (mêmes fichiers que fr/)
// et une entrée ici. Le sélecteur ne propose que les langues dont les fichiers existent (AVAILABLE_LANGUAGES).
import type { ComponentType } from 'react';

export type Language = 'fr' | 'en' | 'hi';

type FlagProps = { className?: string };

export interface LanguageInfo {
  code: Language;
  /** Nom de la langue dans la langue elle-même. */
  label: string;
  /** Locale pour toLocaleString / Intl. */
  locale: string;
  Flag: ComponentType<FlagProps>;
  /** Feuille de styles d'une police à charger quand la langue est choisie (écritures non latines). */
  fontStylesheet?: string;
}

// ─── Drapeaux en SVG (les emojis drapeaux ne s'affichent pas sous Windows) ───

function FlagFR({ className = '' }: FlagProps) {
  return (
    <svg viewBox="0 0 3 2" className={className} aria-hidden="true">
      <rect width="1" height="2" fill="#002395" /><rect x="1" width="1" height="2" fill="#fff" /><rect x="2" width="1" height="2" fill="#ED2939" />
    </svg>
  );
}

function FlagGB({ className = '' }: FlagProps) {
  return (
    <svg viewBox="0 0 60 30" className={className} aria-hidden="true">
      <clipPath id="zos-flag-gb-t"><path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" /></clipPath>
      <path d="M0,0 v30 h60 v-30 z" fill="#012169" />
      <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
      <path d="M0,0 L60,30 M60,0 L0,30" clipPath="url(#zos-flag-gb-t)" stroke="#C8102E" strokeWidth="4" />
      <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10" />
      <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
    </svg>
  );
}

function FlagIN({ className = '' }: FlagProps) {
  // Tiranga : safran, blanc, vert, roue d'Ashoka bleu marine à 24 rayons.
  const spokes = Array.from({ length: 24 }, (_, i) => {
    const a = (i * Math.PI) / 12;
    return <line key={i} x1="45" y1="30" x2={45 + 8.6 * Math.cos(a)} y2={30 + 8.6 * Math.sin(a)} stroke="#000080" strokeWidth="0.7" />;
  });
  return (
    <svg viewBox="0 0 90 60" className={className} aria-hidden="true">
      <rect width="90" height="20" fill="#FF9933" /><rect y="20" width="90" height="20" fill="#fff" /><rect y="40" width="90" height="20" fill="#138808" />
      <circle cx="45" cy="30" r="9.2" fill="none" stroke="#000080" strokeWidth="1.2" />
      <circle cx="45" cy="30" r="1.6" fill="#000080" />
      {spokes}
    </svg>
  );
}

export const LANGUAGE_INFO: Record<Language, LanguageInfo> = {
  fr: { code: 'fr', label: 'Français', locale: 'fr-FR', Flag: FlagFR },
  en: { code: 'en', label: 'English', locale: 'en-GB', Flag: FlagGB },
  hi: {
    code: 'hi', label: 'हिन्दी', locale: 'hi-IN', Flag: FlagIN,
    fontStylesheet: 'https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@400;500;600;700;800&display=swap',
  },
};

export const isLanguage = (v: unknown): v is Language => typeof v === 'string' && v in LANGUAGE_INFO;
